export default function HowItWorks() {
  return <h1>HowItWorks</h1>;
}
